import jQuery from 'jquery';
import {ToggleItem} from "./widget/toggle-item";
import {ToggleGroup} from "./widget/toggle-group";

jQuery.widget("omni.toggleItem", ToggleItem);
jQuery.widget("omni.toggleGroup", ToggleGroup);

